import { render } from "./noticemanger.vue?vue&type=template&id=7b276de2&scoped=true"
import script from "./noticemanger.vue?vue&type=script&lang=js"
export * from "./noticemanger.vue?vue&type=script&lang=js"

import "./noticemanger.vue?vue&type=style&index=0&id=7b276de2&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b276de2"]])

export default __exports__